import { Component } from 'react'
import { connect } from 'react-redux'

import { Button, PortedModal } from '../../../shared/NarusMaterial'

import PlanComponents from './planComponents'
import Services from './services'

class ServicesModal extends Component {
  constructor (props) {
    super(props)
    this.handleClose = this.handleClose.bind(this)
    this.handleOpen = this.handleOpen.bind(this)
    this.state = {
      open: false
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    this.setState(nextProps)
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  handleOpen = () => {
    this.setState({ open: true })
  }

  render () {
    const { open } = this.state
    const { name, component, clientName, clientKey } = this.props
    const actions = [
      <Button
        key={1}
        grey
        label='Close'
        onClick={this.handleClose}
      />
    ]

    return (
      <div>
        <div style={{ display: 'contents' }}>
          <span className='label'>
            <span
              onClick={this.handleOpen}
              className='client-name'
              title='Client Information from ESPO CRM'
              aria-hidden='true'
            >
              {name}
            </span>
          </span>
        </div>
        <PortedModal
          title='Client Services'
          actions={actions}
          onCancel={this.handleClose}
          open={open}
        >
          {component}
          <Services
            inModal
            clientName={clientKey}
          />
          <h2>Plan Components</h2>
          <PlanComponents
            inModal
            clientName={clientName}
          />
        </PortedModal>
      </div>
    )
  }
}

export default connect()(ServicesModal)
